import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ParameterConfig } from './parameter-config';

@Metamodel.model({})
export class ExecuteSSISPackageParameterConfig extends ParameterConfig {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly SCOPE: IAttribute;
    public static readonly REQUIRED: IAttribute;
    public static readonly DELETABLE: IAttribute;
    public static readonly VALUE_SET: IAttribute;
    public static readonly REFERENCED_VARIABLE: IAttribute;
    public static readonly DESIGN_DEFAULT_VALUE: IAttribute;
    public static readonly DEFAULT_VALUE: IAttribute;
    public static readonly VALUE_TYPE: IAttribute;
    public static readonly SENSITIVE: IAttribute;

    public static readonly SCOPE_PACKAGE = 'Package';
    public static readonly SCOPE_PROJECT = 'Project';

    public static readonly TYPE_NA = 'N/A';

    @Metamodel.attribute({
        association: 'SCOPE'
    })
    public scope: string;

    @Metamodel.attribute({
        association: 'REQUIRED'
    })
    public required?: boolean = false;

    @Metamodel.attribute({
        association: 'SENSITIVE'
    })
    public sensitive?: boolean = false;

    @Metamodel.attribute({
        association: 'VALUE_SET'
    })
    public valueSet: boolean = false;

    @Metamodel.attribute({
        association: 'REFERENCED_VARIABLE'
    })
    public referencedVariable?: string;

    @Metamodel.attribute({
        association: 'DESIGN_DEFAULT_VALUE'
    })
    public designDefaultValue?: string;

    @Metamodel.attribute({
        association: 'DEFAULT_VALUE'
    })
    public defaultValue?: string;

    @Metamodel.attribute({
        association: 'VALUE_TYPE'
    })
    public valueType?: string;

    @Metamodel.attribute({
        association: 'DELETEABLE'
    })
    public deletable?: boolean = true;

    public fromJson: boolean = false;

    // eslint-disable-next-line
    public type: string = ExecuteSSISPackageParameterConfig.TYPE_NA;
}
